import React, { useState, useEffect, useRef } from "react";
import CustomBreadcrumbs from "../../Tools/Breadcumbs";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { fetchSchemesOnly, add_subhead_budget } from "../../../helper/Api";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import Spinner from "../../Tools/spinner";

const AddSubHeadForm = () => {
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitLockRef = useRef(false);
  const navigate = useNavigate();
  const [codeError, setCodeError] = useState(false);
  const [schemes, setSchemes] = useState([]);
  const linksArray = [
    {
      href: "/schemes",
      label: "Schemes",
    },
  ];
  const [formData, setFormData] = useState({
    scheme_id: "",
    name: "",
    code: "",
  });

  const fetchSchemes = async () => {
    setLoading(true);
    try {
      const response = await fetchSchemesOnly();
      if (response.status === 200) {
        setSchemes(response.data.schemes);
      } else {
        toast.error("Failed to fetch schemes", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.message || "Error fetching schemes", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchemes();
  }, []);

  const handleSchemFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "code") {
      const numericValue = value.replace(/\D/g, "").slice(0, 2);
      setCodeError(numericValue.length > 0 && numericValue.length !== 2);
      setFormData((prev) => ({ ...prev, code: numericValue }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{2}$/.test(formData.code)) {
      setCodeError(true);
      toast.error("Subhead Code must be exactly 2 digits.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (submitLockRef.current || isSubmitting) {
      return;
    }

    submitLockRef.current = true;
    setIsSubmitting(true);
    setLoading(true);
    try {
      const res = await add_subhead_budget(formData);
      if(res.data.status) {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/schemes");
      }
    }catch(err) {
      toast.error('Something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setLoading(false);
      setIsSubmitting(false);
      submitLockRef.current = false;
    }
  }

  return (
    <>
    {loading && <div > <Spinner/> </div>}
      <div className="row" style={{ padding: "10px 16px" }}>
        <div className="col-md-6">
          <h4>Add Subhead</h4>
          <CustomBreadcrumbs linksArray={linksArray} title="Add Subhead" />
        </div>
        <div className="col-md-6">
          <div
            className="d-flex gap-2"
            style={{ width: "auto", float: "right" }}
          >
            <button
              type="submit"
              className="submit_button"
              onClick={handleSubmit}
              disabled={isSubmitting || loading}
            >
              <span className="fs-14px">{isSubmitting ? "Saving..." : "Save"}</span>
            </button>
          </div>
        </div>
      </div>
      <div className="p-3">
        <Card variant="outlined">
          <CardContent>
            <div className="row">
              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <InputLabel id="scheme-namelabel">Scheme</InputLabel>
                  <Select
                    labelId="scheme-namelabel"
                    id="scheme-name-select"
                    value={formData.scheme_id || ""}
                    label="Scheme"
                    name="scheme_id"
                    onChange={handleSchemFormData}
                  >
                    {schemes.map((scheme) => (
                      <MenuItem value={scheme.id} key={scheme.id}>
                        {scheme.code} | {scheme.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <TextField
                    id="name"
                    label="Subhead Name"
                    variant="outlined"
                    type="text"
                    name="name"
                    onChange={handleSchemFormData}
                    required
                  />
                </FormControl>
              </div>

              <div className="col-sm-4 p-2">
                <FormControl fullWidth>
                  <TextField
                    id="code"
                    label="Subhead Code"
                    variant="outlined"
                    type="text"
                    name="code"
                    onChange={handleSchemFormData}
                    value={formData.code}
                    required
                    error={codeError}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 2 }}
                    helperText={
                      codeError ? "Subhead Code must be 2 digit number" : ""
                    }
                  />
                </FormControl>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default AddSubHeadForm;
